/**
 * 多语言的语言列表
 */
export const LangEnum = [
  {
    show: true,
    lang: "zh-CN",
    label: "中文",
    chinaLabel: "中文"
  },
  {
    show: true,
    lang: "en-US",
    label: "English",
    chinaLabel: "英文"
  },
  {
    show: true,
    lang: "ja-JP",
    label: "日本語",
    chinaLabel: "日语"
  },
  {
    show: false,
    lang: "ko-KR",
    label: "한국어",
    chinaLabel: "韩语"
  },
  {
    show: false,
    lang: "fr-FR",
    label: "Français",
    chinaLabel: "法语"
  },
  {
    show: true,
    lang: "de-DE",
    label: "Deutsch",
    chinaLabel: "德语"
  },
  {
    show: false,
    lang: "es-ES",
    label: "Español",
    chinaLabel: "西班牙语"
  },
  {
    show: false,
    lang: "it-IT",
    label: "Italiano",
    chinaLabel: "意大利语"
  },
  {
    show: false,
    lang: "ru-RU",
    label: "Русский",
    chinaLabel: "俄语"
  },
  {
    show: false,
    lang: "pt-PT",
    label: "Português",
    chinaLabel: "葡萄牙语"
  },
  {
    show: true,
    lang: "th-TH",
    label: "ภาษาไทย",
    chinaLabel: "泰语"
  },
  {
    show: true,
    lang: "vi-VN",
    label: "Tiếng Việt",
    chinaLabel: "越南语"
  },
  {
    show: true,
    lang: "ms-MY",
    label: "Bahasa Melayu",
    chinaLabel: "马来西亚语"
  },
  {
    show: true,
    lang: "id-ID",
    label: "Bahasa Indonesia",
    chinaLabel: "印度尼西亚语"
  },
  {
    show: false,
    lang: "tl-PH",
    label: "Filipino",
    chinaLabel: "菲律宾语"
  },
  {
    show: false,
    lang: "my-MM",
    label: "မြန်မာဘာသာ",
    chinaLabel: "缅甸语"
  },
  {
    show: false,
    lang: "lo-LA",
    label: "ພາສາລາວ",
    chinaLabel: "老挝语"
  },
  {
    show: false,
    lang: "ta-IN",
    label: "தமிழ்",
    chinaLabel: "泰米尔语"
  }
];

let LanguageVariants = null;

// 获取多语言对应的 accept-language
export const getLanguageVariants = () => {
  if (LanguageVariants == null) {
    LanguageVariants = {};
    LangEnum.forEach(item => {
      if (item.show) {
        LanguageVariants[item.lang] = [
          `${item.lang};q=0.9,en;q=0.8,zh-CN;q=0.7`
        ];
      }
    });
  }
  return LanguageVariants;
};
